<!------------------------- header start ------------------------------>
<header>
  <!-- navbar start -->
  <!-- navbar start -->
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand ml-5" routerLink="/home"><img src="/assets/About/image/logo.svg" alt="Logo" /></a>
      <button class="navbar-toggler navbar-dark" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mx-lg-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page"  routerLink="/coverage">Coverage</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/learningCenter">Learning Center</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"  routerLink="/about">About </a>
          </li>
        </ul>
      </div>

      <ul class="navbar-nav last-navbar ml-lg-auto ml-0 mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link btn btn-orange" href="#">Get a quota</a>
        </li>
        <li class="nav-item user">
          <a class="nav-link" href="#"> <i class="far fa-user"></i> </a>
        </li>
      </ul>
    </div>
  </nav>

  <!-- navbar end -->

  <!-- hero area start -->
  <section class="hero-area">
    <div class="containre">
      <div class="hero-body">
        <div class="row">
          <div class="col-lg-6 col-md-8 col-sm-10 mx-auto">
            <h1>We’re Redefining Real Estate Insurance</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- hero area end -->
</header>
<!------------------------- header end ------------------------------>

<!------------------------- simplicity start ------------------------------>
<section class="simplicity">
  <div class="container">
    <div class="row">
      <div class="col-md-7 mx-auto">
        <h1 class="simplicity-header">Bringing <span>simplicity</span> and <span>transparency</span> to real estate insurance</h1>
      </div>
    </div>
    <div class="sim-body">
      <div class="row">
        <div class="col-md-6 mx-0 my-5 p-0"><img src="/assets/About/image/about-sim.png" alt="Photo" class="img-fluid"></div>
        <div class="col-md-6">
          <div class="sim-post pl-md-5 pl-0">
            <div class="sim-post-body">
              <h2>Building on Experience</h2>
              <p>We're a group of online insurance veterans who've been building insurance technologies long before the term "InsureTech" was coined — now we're driving what it means for the future.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mx-0 my-5 p-0 d-md-none d-block"><img src="/assets/About/image/about-sim1.png" alt="Photo" class="img-fluid"></div>
        <div class="col-md-6">
          <div class="sim-post pr-5">
            <div class="sim-post-body">
              <h2>People-Focused, Tech-Driven</h2>
              <p>We're simplifying the way you navigate the commercial real estate insurance process at every point, which makes finding better coverage at a more affordable price easier than ever before. </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 mx-0 mt-5 p-0 d-md-block d-none"><img src="/assets/About/image/about-sim1.png" alt="Photo" class="img-fluid"></div>
      </div>
    </div>
  </div>
</section>

<section class="frequently">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-4 mr-auto">
        <p class="orange-text mb-3">About Honeycomb</p>
        <h2>Frequently Asked Questions</h2>
      </div>
      <div class="col-lg-6 col-md-8 overflow-hidden">
        <div class="collapse-body " >
          <div class="accordion" id="accordionExample">
            <div class="card">
              <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                  <button class="btn collapse-b btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    How is buying insurance from Honeycomb different than buying from a traditional agent?
                  </button>
                </h2>
              </div>

              <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body">
                  The financial strength of our partner insurance companies who are the ones responsible to pay your claims, is A/A++. Financial strength rating agencies such as AM best do not rank insurance brokerages such as Honeycomb.
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingTwo">
                <h2 class="mb-0">
                  <button class="btn collapse-b btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                    What is your financial strength rating?
                  </button>
                </h2>
              </div>

              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                <div class="card-body">
                  The financial strength of our partner insurance companies who are the ones responsible to pay your claims, is A/A++. Financial strength rating agencies such as AM best do not rank insurance brokerages such as Honeycomb.
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingThree">
                <h2 class="mb-0">
                  <button class="btn collapse-b btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                    How is buying insurance from Honeycomb different than buying from a traditional agent?
                  </button>
                </h2>
              </div>

              <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                <div class="card-body">
                  The financial strength of our partner insurance companies who are the ones responsible to pay your claims, is A/A++. Financial strength rating agencies such as AM best do not rank insurance brokerages such as Honeycomb.
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingFour">
                <h2 class="mb-0">
                  <button class="btn collapse-b btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                    How is buying insurance from Honeycomb different than buying from a traditional agent?
                  </button>
                </h2>
              </div>

              <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                <div class="card-body">
                  The financial strength of our partner insurance companies who are the ones responsible to pay your claims, is A/A++. Financial strength rating agencies such as AM best do not rank insurance brokerages such as Honeycomb.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!------------------------- simplicity end ------------------------------>

<!------------------------- frequently start ------------------------------>
<!--<section class="frequently">-->
<!--  <div class="container">-->
<!--    <div class="row">-->
<!--      <div class="col-lg-4 col-md-4 mr-auto">-->
<!--        <p class="orange-text mb-3">About Honeycomb</p>-->
<!--        <h2>Frequently Asked Questions</h2>-->
<!--      </div>-->
<!--      <div class="col-lg-6 col-md-8">-->
<!--        <div class="collapse-body">-->
<!--          <div class="accordion" id="accordionExample">-->
<!--            <div class="card">-->
<!--              <div class="card-header" id="headingOne">-->
<!--                <h2 class="mb-0">-->
<!--                  <button class="btn collapse-b btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">-->
<!--                    How is buying insurance from Honeycomb different than buying from a traditional agent?-->
<!--                  </button>-->
<!--                </h2>-->
<!--              </div>-->

<!--              <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">-->
<!--                <div class="card-body">-->
<!--                  The financial strength of our partner insurance companies who are the ones responsible to pay your claims, is A/A++. Financial strength rating agencies such as AM best do not rank insurance brokerages such as Honeycomb.-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="card">-->
<!--              <div class="card-header" id="headingTwo">-->
<!--                <h2 class="mb-0">-->
<!--                  <button class="btn collapse-b btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">-->
<!--                    What is your financial strength rating?-->
<!--                  </button>-->
<!--                </h2>-->
<!--              </div>-->

<!--              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">-->
<!--                <div class="card-body">-->
<!--                  The financial strength of our partner insurance companies who are the ones responsible to pay your claims, is A/A++. Financial strength rating agencies such as AM best do not rank insurance brokerages such as Honeycomb.-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="card">-->
<!--              <div class="card-header" id="headingThree">-->
<!--                <h2 class="mb-0">-->
<!--                  <button class="btn collapse-b btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">-->
<!--                    How is buying insurance from Honeycomb different than buying from a traditional agent?-->
<!--                  </button>-->
<!--                </h2>-->
<!--              </div>-->

<!--              <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">-->
<!--                <div class="card-body">-->
<!--                  The financial strength of our partner insurance companies who are the ones responsible to pay your claims, is A/A++. Financial strength rating agencies such as AM best do not rank insurance brokerages such as Honeycomb.-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="card">-->
<!--              <div class="card-header" id="headingFour">-->
<!--                <h2 class="mb-0">-->
<!--                  <button class="btn collapse-b btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">-->
<!--                    How is buying insurance from Honeycomb different than buying from a traditional agent?-->
<!--                  </button>-->
<!--                </h2>-->
<!--              </div>-->

<!--              <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">-->
<!--                <div class="card-body">-->
<!--                  The financial strength of our partner insurance companies who are the ones responsible to pay your claims, is A/A++. Financial strength rating agencies such as AM best do not rank insurance brokerages such as Honeycomb.-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</section>-->
<!------------------------- frequently end ------------------------------>


<!-----------------------  management start ----------------------->
<section class="management">
  <div class="container">
    <h2>Management Team</h2>
    <div class="row">
      <div class="col-lg-3 col-md-6 mt-4">
        <div class="card">
          <img src="/assets/About/image/about-card1.png" class="card-img-top" alt="Photo">
          <div class="card-body">
            <h5 class="card-title">Itai Ben-Zaken</h5>
            <p class="orange-text">Co-Founder & CEO</p>
            <p class="card-text">Insurance GM at NASDAQ:QNST</p>
            <p class="card-text">Managed $100M portfolio of online insurance comparison products</p>
          </div>
        </div>

      </div>

      <div class="col-lg-3 col-md-6 mt-4">
        <div class="card">
          <img src="/assets/About/image/about-card2.png" class="card-img-top" alt="Photo">
          <div class="card-body">
            <h5 class="card-title">Manny Rios</h5>
            <p class="orange-text">Co-Founder & CUO</p>
            <p class="card-text">Chief Underwriting Officer of USAA</p>
            <p class="card-text">CEO of American Modern</p>
          </div>
        </div>

      </div>

      <div class="col-lg-3 col-md-6 mt-4">
        <div class="card">
          <img src="/assets/About/image/about-card3.png" class="card-img-top" alt="Photo">
          <div class="card-body">
            <h5 class="card-title">Adam Cherubini</h5>
            <p class="orange-text">Co-Founder & CRO</p>
            <p class="card-text">25 year insurance industry veteran</p>
            <p class="card-text">Insurance SVP at NASDAQ:QNST</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 mt-4">
        <div class="card">
          <img src="/assets/About/image/about-card4.png" class="card-img-top" alt="Photo">
          <div class="card-body">
            <h5 class="card-title">Dr. Nimrod Sadat</h5>
            <p class="orange-text">Co-Founder & CTO</p>
            <p class="card-text">Versatile hands-on software leader with more than 15 years of experience</p>
            <p class="card-text">Stanford PhD</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
<!-----------------------  management end ----------------------->

<!-----------------------  coverage start ----------------------->
<section class="coverage">
  <div class="container">
    <div class="coverage-body">
      <div class="row">
        <div class="col-md-6">
          <h3>Better coverage is closer than you think</h3>
        </div>
        <div class="col-md-6 px-5 pt-4">
          <p class="coverage-text coverage-text1">Tell us about your property</p>
          <p class="coverage-text coverage-text2">Get an instant, personalized quote</p>
          <p class="coverage-text coverage-text3">Enjoy up to 50% savings</p>
        </div>
        <div class="col-md-6">
          <p class="text-center mt-md-0 mt-5"><a href="#" class="btn-orange d-block w-50 mx-auto">Get Start</a></p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-----------------------  social start ----------------------->
<div class="social py-5">
  <div class="container-fluid">
    <img src="/assets/image/Vector.svg" class="d-lg-block d-none mx-auto" alt="Logo" />
    <img src="/assets/Coverage/image/logo.svg" class="d-lg-none d-block mx-auto" alt="Logo">
  </div>
  <p class="social-links text-center d-lg-none d-block mt-4">
    <a href="#"><i class="fab fa-facebook-square"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-linkedin"></i></a>
  </p>
  <nav>
    <div class="container-fluid my-5">
      <p class="text-center">
        <a routerLink="/coverage">Coverage</a>
        <a routerLink="/learningCenter">Learning Center</a>
        <a routerLink="/expertAsk">Ask The Expert</a>
        <a routerLink="/about">About</a>
      </p>
    </div>
  </nav>

  <p class="social-links text-center d-lg-block d-none">
    <a href="#"><i class="fab fa-facebook-square"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-linkedin"></i></a>
  </p>
</div>
<!-----------------------  social end ----------------------->
<!------------------------- footer start ------------------------------>
<footer>
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <p class="text-lg-left d-lg-block d-none text-center"> &#169; 2020 Honeycomb Insurance. All rights reserved.</p>
        <p class="text-lg-left d-lg-none d-block text-center"> &#169; © 2020 Acme. All right reserved.</p>
      </div>
      <div class="col-lg-6">
        <p class="text-lg-right text-center">
          <a href="#" class="d-lg-inline d-block">Privacy Policy</a>
          <a href="#" class="d-lg-inline d-block my-4">Terms of Service</a>
        </p>
      </div>
    </div>
  </div>
</footer>
<!------------------------- footer end ------------------------------>

